var isLoggingEnabled = true;
export function info(title, object, type) {
    var titleStyle = 'border-radius: 4px; padding: 4px; font-weight: bold;';
    if (!type) {
        titleStyle = ''.concat(titleStyle, ' background-color: #5a5a5a; color: #fff;');
    }
    else if (type.toLowerCase() === 'transmit') {
        titleStyle = ''.concat(titleStyle, ' font-family: roboto-bold,roboto,sans-serif; background-color: #eb690b; color: #fff;');
    }
    else if (type.toLowerCase() === 'component') {
        titleStyle = ''.concat(titleStyle, ' font-family: roboto-bold,roboto,sans-serif; background-color: #006ace; color: #fff;');
    }
    if (isLoggingEnabled) {
        console.log('%c'.concat(title), titleStyle, object);
    }
}
export function updateisLoggingEnabled(value) {
    isLoggingEnabled = value;
}
export function error(message, object) {
    var titleStyle = 'border-radius: 4px; padding: 4px; font-weight: bold; background-color: #993131; color: #fff;';
    if (isLoggingEnabled) {
        console.error('%cError', titleStyle, message);
    }
    if (object) {
        console.log(object);
    }
}
